<template lang="html" ref="linkedinInfoPopupContainer">
	<vs-popup :active.sync="$props.popupActive" :title="'Contact LinkedIn: ' + $props.prospect_url">
		<div v-if = "isLoading" class="text-center">
			<circular-loader/>
		</div>
        <div v-else
		class="flex flex-wrap">
            <vs-table
		search
		stripe pagination max-items="25"
		:key = "employeeTableKey"
		:data="linkedinInfo.employees"
		noDataText="Aucune employés corresponde"
    >
	<template slot="header">
        <h3>
            Les employés
        </h3>
      </template>
    <template slot="thead">
	<vs-th class="th-sticky" sort-key="name"></vs-th>
	<vs-th class="th-sticky" sort-key="name">Nom Prenom</vs-th>
	<vs-th class="th-sticky pdl0" sort-key="type">Poste</vs-th>
	<vs-th class="th-sticky pdl0" sort-key="urls">Campaign</vs-th>
	<vs-th class="th-sticky pdl0" sort-key="urls"></vs-th>
	<vs-th class="th-sticky pdl0" sort-key="urls"></vs-th>
</template>

    <template slot-scope="{data}">
	<vs-tr :key="index" v-for="(employee, index) in data">
		<vs-td style="width: 15%" :data="employee.lastName">
			<vs-icon
				v-if="employee.relevanceScore > 7"
				icon="star"
				size="medium"
				style="color: orange"
			></vs-icon>
		</vs-td>
		<vs-td style="width: 15%" :data="employee.lastName">
			<a target="_blank" :href="employee.linkedinUrl">
				<span class="m-0 cursor-pointer">
					{{ employee.lastName + " " + employee.firstName }}
				</span>
			</a>
		</vs-td>
		<vs-td style="width: 30%" :data="employee.jobTitle">
			{{ employee.jobTitle }}
		</vs-td>
		<vs-td :data="employee.index">
			<vs-select
				autocomplete
				v-if="!isActivityLoading"
				v-model="
					employee.leadInfo.length > 0 && employee.leadInfo[0].is_sent == 1
						? employee.leadInfo[0].campaignId
						: employee.campaignId
				"
				class="w-3/4 select-large mt-4"
				placeholder="Campaign"
				:disabled="
					employee.leadInfo.length > 0 && employee.leadInfo[0].is_sent == 1
				"
			>
				<vs-select-item
					:key="index"
					:value="item._id"
					:text="item.name"
					v-for="(item, index) in campaignList"
					class="w-full"
				/>
			</vs-select>
		</vs-td>
		<vs-td :data="employee.index">
			<div class="flex justify-center items-center">
				<vs-button
					v-if="employee.leadInfo.length == 0"
					icon="send"
					@click="
						launchCampaignForOneLead(
							employee.linkedinUrl,
							employee.campaignId,
							employee.id,
							index
						)
					"
					>Envoyer</vs-button
				>
				<div
					v-else-if="employee.alreadyContacted.length > 0"
					class="cursor-pointer"
				>
					<vx-tooltip
						:text="getAlreadyContactedText(employee.alreadyContacted)"
					>
						<vs-icon icon="check" size="small" style="color: green"> </vs-icon>
					</vx-tooltip>
				</div>
				<!-- <div v-else="employee.leadInfo[0].is_sent == 0"> -->
				<div v-else>
					<div v-if="employee.leadInfo[0].is_sent" class="text-center">
						<vs-icon icon="check" size="small" style="color: green"> </vs-icon>
					</div>
					<div v-else>
						<circular-loader></circular-loader>
					</div>
				</div>
			</div>
		</vs-td>
		<vs-td>
			<div
				v-if="
					employee.leadInfo.length == 0 && employee.alreadyContacted.length > 0
				"
			>
				<div class="cursor-pointer">
					<vx-tooltip
						:text="getAlreadyContactedText(employee.alreadyContacted)"
					>
						<vs-icon icon="warning" color="warning" size="small"></vs-icon>
					</vx-tooltip>
					<!-- getActivityText(employee.id) -->
				</div>
			</div>
			<div v-else-if="employee.leadInfo.length > 0">
				<div v-if="isActivityLoading" class="text-center">
					<circular-loader />
				</div>
				<div v-else>
					<!-- getActivityText(employee.id) -->
					<vx-tooltip :text="getActivityText(employee.id)">
						<div
							@click="displayActivitesHistory(employee.id)"
							class="cursor-pointer"
						>
							<vs-icon
								:icon="getActivity(employee.id)['icon_name']"
								:color="getActivity(employee.id)['color']"
								size="small"
							></vs-icon>
						</div>
					</vx-tooltip>
				</div></div
		></vs-td>
	</vs-tr>
</template>
    </vs-table>
            
   
</div>
		
	</vs-popup>
</template>

<script>
import Vue from "vue";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import VueCookies from "vue-cookies";
import store from "@/store/store";
import ProspectSearch from "@/entities/ProspectSearch";
import CircularLoader from "../../../widgets/loader/CircularLoader.vue";
import FeatherIcon from "../../../widgets/FeatherIcon.vue";
import LemlistHistoryActivityPopup from "./LemlistHistoryActivityPopup.vue";
import moment from "moment";
export default {
	created() {
		this.fetchLinkedinInfos();
		this.getAllCampaigns();
		this.fetchActivities();
		//getting orders which belongs to user sign in
	},
	updated() {
		// //console.log("dsadsads");
		// this.getNotes();
	},
	components: { CircularLoader, FeatherIcon },
	mounted() {},
	name: "PropsectTechnologyPopup",
	mixins: [dbFieldConvertor],
	props: {
		popupActive: {
			type: Boolean,
			required: true,
		},
		prospectId: {
			type: Number,
			required: true,
		},
		prospect_url: {
			type: String,
			required: true,
		},
	},

	data() {
		return {
			// apiUrl: this.$store.state.backendApiUrl,
			isLoading: false,
			linkedinInfo: {},
			keysTechnologies: [],
			campaignList: [],
			selectChoice: "",
			activities: [],
			isActivityLoading: false,
			employeeTableKey: 0,
			showlemlistActivityPopup: false,
			employeeTableKey: 0,
			// Activites
		};
	},
	watch: {
		campaignList: function (val) {
			if (!val) {
				this.$vs.notify({
					title: "Info",
					text: "Aucune campagne trouvée !. Veuillez créer une campagne",
					color: "warning",
				});
			}
		},
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},

		apiUrl: () => {
			return store.state.backendApiUrl;
		},
	},
	methods: {
		async fetchLinkedinInfos() {
			try {
				this.isLoading = true;
				let response = await ProspectSearch.getProspectEmployees(
					this.$props.prospectId
				);
				this.linkedinInfo = response;
			} catch (err) {
				this.$vs.notify({
					title: "Erreur",
					text: "Une erreur est survenue lors de la récupération des employés",
					color: "danger",
				});
			} finally {
				this.isLoading = false;
			}
		},
		async launchCampaignForOneLead(linkedinUrl, campaignId, employeeId, index) {
			try {
				await ProspectSearch.launchCampaignForOneLead(
					linkedinUrl,
					campaignId,
					employeeId,
					this.$props.prospectId,
					this.activeUser.id
				);
				this.$vs.notify({
					title: "Campagne lancée",
					text: "La campagne a été lancée avec succès",
					color: "success",
				});
				this.linkedinInfo.employees[index].leadInfo = [
					{
						is_sent: 1,
						campaignId: campaignId,
					},
				];
			} catch (e) {
				console.log("Error: launchCampaignForOneLead", e);
				this.$vs.notify({
					title: "Erreur",
					text: "Une erreur est survenue lors du lancement de la campagne",
					color: "danger",
				});
			}
		},
		async getAllCampaigns() {
			try {
				this.campaignList = await ProspectSearch.getLemlistCampaignListBySender(
					this.activeUser.email
				);
			} catch (e) {
				console.log("Error: getAllCampaigns", e);
				this.$vs.notify({
					title: "Erreur",
					text: "Une erreur est survenue lors de la récupération des campagnes",
					color: "danger",
				});
			}
		},
		async fetchActivities() {
			this.isActivityLoading = true;
			try {
				this.activities = await ProspectSearch.getLeadActivitesByProspectId(
					this.$props.prospectId
				);
			} catch (err) {
				this.$vs.notify({
					title: "Erreur",
					text: "Une erreur est survenue lors de la récupération des activités",
					color: "danger",
				});
			} finally {
				this.isActivityLoading = false;
				this.employeeTableKey++;
			}
		},
		getSentCampaign(employeeId) {
			let activity = this.activities.find(
				(activity) => activity.employeeId == employeeId
			);
			return activity ? activity.activites[0].campaignId : "";
		},
		getActivity(employeeId) {
			try {
				let activity = this.activities.find(
					(activity) => activity.employeeId == employeeId
				);
				return activity.activites[0].typeObject;
			} catch (e) {
				return {
					icon_name: "loop",
					color: "#A7A7A7FF",
				};
			}
		},
		getAllActivites(employeeId) {
			let activity = this.activities.find(
				(activity) => activity.employeeId == employeeId
			);
			return activity ? activity.activites : [];
		},
		getActivityText(employeeId) {
			try {
				let activity = this.activities.find(
					(activity) => activity.employeeId == employeeId
				);
				let errorText = activity.activites[0].errorMessage
					? " - " + activity.activites[0].errorMessage
					: "";
				let activityText = activity
					? activity.activites[0].typeObject.text
					: "";
				return (
					activityText +
					errorText +
					" ( " +
					moment(activity.activites[0].created_date).format("DD/MM/YYYY") +
					" )"
				);
			} catch (e) {
				return "En cours";
			}
		},
		/**
		 * Get already contacted text for a lead
		 * @param data
		 */
		getAlreadyContactedText(data) {
			try {
				// Extract campaign names and join them into a string
				const campaignNames = data.map((item) => item.campaignName).join(", ");
				return `Déjà contacté via Campaign: ${campaignNames} ( ${moment(
					data[0].updated_date
				).format("DD/MM/YYYY")} ) par ${data[0].senderName || ""}`;
			} catch (e) {
				return "Déjà contacté";
			}
		},
		displayActivitesHistory(employeeId) {
			this.showlemlistActivityPopup = true;
			// Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(LemlistHistoryActivityPopup);
			let lemlistActivityPopup = new ComponentClass({
				propsData: {
					popupActive: this.showlemlistActivityPopup,
					activites: this.getAllActivites(employeeId),
					zIndex: 99999999,
				},
			});
			lemlistActivityPopup.$mount();
			this.$refs.linkedinInfoPopupContainer.appendChild(
				lemlistActivityPopup.$el
			);
			lemlistActivityPopup.$on("close-popup", (data) => {
				this.showlemlistActivityPopup = false;
			});
		},
	},
};
</script>
